import React, { Component } from "react";
import NavBar from "../components/NavBar";
import Sidebar from "./components/Sidebar";
import ServiceGallery from "./components/ServiceGallery"
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
class HolisticChildDevelopment extends Component {
  render() {
    return (
      <div>
        {/* Navigation bar */}
        <NavBar />

        {/* breadcrumb */}
        {/*====================  breadcrumb area ====================*/}
        <div
          className="breadcrumb-area breadcrumb-bg"
          style={{
            backgroundImage: `url(assets/img/backgrounds/funfact-bg.jpg)`
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="page-banner text-center">
                  <h1>Holistic Child Development Programs</h1>
                  <ul className="page-breadcrumb">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li>
                      <a href={`${process.env.PUBLIC_URL}/services`}>
                        Services
                      </a>
                    </li>
                    <li>Holistic Child Development Programs</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*====================  End of breadcrumb area  ====================*/}

        <div className="page-wrapper section-space--inner--120">
          {/*Service section start*/}
          <div className="service-section">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 col-12 order-1 order-lg-2">
                  <div className="service-details">
                    {/* service gallery */}
                    <ServiceGallery />

                    <div className="content section-space--top--30">
                      <h2>Holistic Child Development Programs</h2>

                      <p>
                        Every child is unique, and true development goes beyond academic achievement. Holistic Child Development Programs are designed to nurture all areas of a child’s growth, including physical, cognitive, communication, emotional, social, behavioural, and adaptive skills. By focusing on the child as a whole, these programs help build a strong foundation for lifelong learning, independence, and overall well-being. </p>
                      <p>
                        Our programs are thoughtfully designed to meet the individual needs of each child through comprehensive assessment and personalized intervention plans. A multidisciplinary approach ensures that children receive the right combination of educational support and therapeutic services to address their developmental goals. This integrated model promotes balanced growth and enables children to develop the confidence and skills needed to participate successfully at home, in school, and within their communities. </p>

                      <h3 className="section-space--top--50">Our Holistic Approach</h3>

                      <p>
                        The program incorporates evidence-based practices, play-based learning, sensory-rich activities, communication development, social interaction, behaviour support, and life skills training in an engaging and nurturing environment. Each activity is carefully planned to encourage curiosity, creativity, problem-solving, independence, and meaningful participation in everyday experiences. </p>
                      <p>
                        Holistic Child Development Programs are beneficial for children with developmental delays, autism spectrum disorder, ADHD, learning disabilities, speech and language delays, sensory processing challenges, and other developmental needs. Equally important, parents and caregivers are actively involved throughout the intervention process, ensuring consistency and continued progress beyond therapy sessions. </p>
                      <p>
                        By bringing together education, therapy, and family collaboration, these programs support children in reaching developmental milestones while strengthening their confidence, resilience, and ability to adapt to different environments. Our goal is not only to help children overcome challenges but also to recognize and nurture their strengths, enabling them to thrive in every stage of life.
                      </p>

                      <h3 className="section-space--top--50">Conclusion</h3>
                      <p>
                        At Shakuntla Learn and Fly Foundation, we are committed to supporting every child’s overall development through compassionate care, individualized planning, and evidence-based practices. Our Holistic Child Development Programs empower children to build essential life skills, discover their unique abilities, and achieve their fullest potential. Together with families, we create an environment where every child is encouraged to learn, grow, and flourish with confidence.</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-12 order-2 order-lg-1">
                  <Sidebar />
                </div>
              </div>
            </div>
          </div>
          {/*Service section end*/}
        </div>

        {/* Footer */}
        <Footer />

        {/* Mobile Menu */}
        <MobileMenu />
      </div>
    );
  }
}

export default HolisticChildDevelopment;
